import { DatabaseStorageContentType } from '@databases/types/database';

export function getDatabasePath(database: {
  space: { key: string };
  contentId: string;
}): string {
  return `/spaces/${encodeURIComponent(database.space.key)}/database/${encodeURIComponent(
    database.contentId
  )}`;
}

export function getEntryPath(
  database: {
    space: { key: string };
    contentId: string;
    type: DatabaseStorageContentType;
  },
  entryId: string
): string {
  return `/spaces/${encodeURIComponent(database.space.key)}/database/${
    database.contentId
  }?entryId=${entryId}`;
}

export function matchEntryPath(
  url: string
): { spaceKey: string; contentId: string; entryId: string } | undefined {
  const m = url.match(/\/spaces\/([^/?#]+)\/database\/([^/?#]+)\?entryId=([^/?#]+)$/);
  if (m) {
    return {
      spaceKey: decodeURIComponent(m[1]),
      contentId: decodeURIComponent(m[2]),
      entryId: decodeURIComponent(m[3]),
    };
  }
}

/**
 * Match the content ID in the given page or blogpost URL. If no content ID can be found (for example
 * because the given URL is not a page or blogpost URL), undefined is returned.
 */
export function matchViewPageOrBlogpostPath(
  url: string,
  fallbackId?: string
): { contentId: string } | undefined {
  let m = url.match(/\/spaces\/[^/?#]+\/pages\/([0-9]+)($|[/?#])/);
  if (m) {
    return { contentId: m[1] };
  }

  m = url.match(/\/spaces\/[^/?#]+\/overview\?(.*&)?homepageId=([0-9]+)/);
  if (m) {
    return { contentId: m[2] };
  }

  // when no homepageId parameter is defined we use the fallbackId
  m = url.match(/\/spaces\/[^/?#]+\/overview/);
  if (m && fallbackId) {
    return { contentId: fallbackId };
  }

  m = url.match(/\/spaces\/[^/?#]+\/blog\/[0-9]+\/[0-9]+\/[0-9]+\/([0-9]+)($|[/?#])/);
  if (m) {
    return { contentId: m[1] };
  }

  m = url.match(/\/pages\/viewpage\.action\?(.*&)?pageId=([0-9]+)/);
  if (m) {
    return { contentId: m[2] };
  }
}

export function matchUserPath(url: string): { accountId: string } | undefined {
  const m = url.match(/\/people\/([^/?#]+)/);
  if (m) {
    return {
      accountId: m[1],
    };
  }
}
